import { forwardRef } from 'react';
import classNames from 'classnames/bind';

import NoContent from './NoContent';
import ProviderFilingRow from './ProviderFilingRow';
import Preloader from '../../../Preloader';
import StoryCaughtUp from '../../../StoryCaughtUp';

import withComponentName from '../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const ProviderFilingsLists = forwardRef(({
  filings, isExpandAll, filingsPageLoad, handleFilterReset,
  isInitialFilingsCall, hasSourceAccess, newFilingsLoading, onReset,
  isSource, isCompany, hasNextPage, isWatchlists,
}, ref) => {
  const filingsListClass = cx('filings_lists',
    { updating_filings_lists: filingsPageLoad, watchlists: isWatchlists });
  return (
    <div className={filingsListClass} ref={ref}>
      {
        !filings.length && isInitialFilingsCall && !filingsPageLoad
          ? (
            <NoContent
              handleFilterReset={handleFilterReset}
              hasSourceAccess={hasSourceAccess}
              onReset={onReset}
            />
          )
          : null
      }
      {
        filings.map((filing) => (
          <ProviderFilingRow
            key={filing.filingId}
            isExpandAll={isExpandAll}
            isSource={isSource}
            isCompany={isCompany}
            {...filing}
          />
        ))
      }
      {newFilingsLoading && (
        <Preloader
          loading
          static
          centered
        />
      )}
      {filings.length && isInitialFilingsCall && !filingsPageLoad && !hasNextPage
        ? <StoryCaughtUp hideButton />
        : null}
    </div>
  );
});

export default withComponentName(ProviderFilingsLists);
